export default "__VITE_ASSET__D18$N4eM__"